export default __webpack_public_path__ + "static/media/Shower - Coral.408ee5b0.svg";